import { useState, useCallback, useEffect } from "react";
import { validateCollaborationDetailsForm } from "../../../validations/generalForm";
import { useToastPromise } from "../../../components/toastPromise";
import { GeneralController } from "../../../controllers/generalController";
import { CollaborationController } from "../../../controllers/collaborationController";
import { Dropdown } from "../../../components/dropdown";
import Button from "@mui/material/Button";
import "../../../assets/css/setttings.css";

export const CollaborationDetails = ({ user }) => {
  const toastPromise = useToastPromise();
  const initialInputs = {
    existingCollaboration: "",
  };
  const [inputs, setInputs] = useState(initialInputs);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [collaborations, setCollaborations] = useState([]);
  const saveInputs = (name, value) => {
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const resetForm = () => {
    setInputs(initialInputs);
    setErrors({});
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = validateCollaborationDetailsForm(inputs);
    setErrors(newErrors);
    if (Object.keys(newErrors).length !== 0) {
      console.debug("Form submission failed due to validation errors.");
      return;
    }
    console.debug("Form validated successfully.");
    saveGeneral();
  };
  const onHandleChange = useCallback((value, name) => {
    saveInputs(name, value);
  }, []);
  const saveGeneral = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        inputs.id
          ? GeneralController.update({
              parameters: {
                ...inputs,
                id: inputs.id,
                lastModifiedBy: user.uid,
                lastModifiedDate: new Date().toLocaleString(),
              },
              resolve: resolve,
              reject: reject,
            })
          : GeneralController.add({
              parameters: {
                ...inputs,
                createdBy: user.uid,
                createdDate: new Date().toLocaleString(),
                lastModifiedBy: user.uid,
                lastModifiedDate: new Date().toLocaleString(),
              },
              resolve: resolve,
              reject: reject,
            });
      }),
      successMessage: (data) => {
        console.debug(data);
        return data;
      },
      errorMessage: (data) => data,
    }).finally(() => {
      setLoading(false);
      resetForm();
      getAll();
    });
  };
  const getAllCollaborations = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        CollaborationController.getAll({
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) => {
        const fetchedData = data.docs.map((doc) => ({
          label: doc.data().title,
          value: doc.id,
        }));
        setCollaborations(fetchedData);
        return "Collaboration details retrieved successfully.";
      },
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  const getAll = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        GeneralController.getAll({
          resolve: resolve,
          reject: reject,
        });
      }),
      successMessage: (data) => {
        const fetchedData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        if (fetchedData.length > 0) {
          setInputs(fetchedData[0]);
        }
        return "Collaboration details retrieved successfully.";
      },
      errorMessage: (data) => data,
    }).finally(() => setLoading(false));
  };
  useEffect(() => {
    getAllCollaborations();
    getAll();
  }, []);

  return (
    <section id="collaborationDetails">
      <h4>COLLABORATION</h4>
      <hr />
      <Button onClick={handleSubmit} disabled={loading}>
        {loading ? "Saving" : "Save"}
      </Button>
      <form onSubmit={handleSubmit}>
        <div>
          <Dropdown
            name="existingCollaboration"
            title="Existing Collaboration"
            value={inputs?.existingCollaboration}
            options={collaborations}
            onChangeFunc={onHandleChange}
            isClearable={false}
            placeholder="Existing Collaboration"
            errorMsg={errors.existingCollaboration}
          />
        </div>
      </form>
    </section>
  );
};
